import * as React from "react";
import { Box } from "@mui/material";

export default function SpecialText({ children, style }) {
  return (
    <Box component="span" sx={style}>
      {children}
    </Box>
  );
}
